import React from "react";
import { Button } from "react-bootstrap";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { useOrderEligibility } from "../../../CustomHook/useOrderEligibility";
import SpinnerComponent from "../../SpinnerComponent/SpinnerComponent";
import "../Main.css";

function getNextOpenMonthLabel(nextOpen) {
  if (!nextOpen) {
    return "";
  }

  return new Intl.DateTimeFormat("es-AR", {
    month: "long",
  }).format(new Date(nextOpen));
}

const statusContentStyle = {
  width: "100%",
};

const SedeMain = () => {
  const role = Cookies.get("role");
  const isSedeUser = role === "sede";
  const { eligibility, loading, error, refetch } = useOrderEligibility(
    undefined,
    isSedeUser
  );

  const nextOpenMonth = getNextOpenMonthLabel(eligibility?.window?.nextOpen);

  const renderEligibilityStatus = () => {
    if (!isSedeUser) {
      return null;
    }

    if (error) {
      return (
        <div style={statusContentStyle}>
          <p className="mb-2">
            No pudimos verificar el estado de tus pedidos en este momento.
          </p>
          <Button
            className="button-sede-main"
            onClick={refetch}
            size="sm"
          >
            Reintentar
          </Button>
        </div>
      );
    }

    if (!eligibility) {
      return null;
    }

    if (eligibility.allowed) {
      return (
        <p className="mb-0">
          {eligibility.window?.isOpen
            ? "Periodo de pedido abierto con cupo disponible."
            : "Periodo de pedido cerrado, pero con cupo disponible para realizar pedidos."}
        </p>
      );
    }

    if (eligibility.reason === "OUT_OF_WINDOW") {
      return (
        <p className="mb-0">
          {nextOpenMonth
            ? `El periodo abre el dia 20 de ${nextOpenMonth}.`
            : "El periodo abre el dia 20."}
        </p>
      );
    }

    if (eligibility.reason === "QUOTA_EXHAUSTED") {
      return <p className="mb-0">Ya usaste tus pedidos de este mes.</p>;
    }

    return (
      <p className="mb-0">
        No pudimos determinar la elegibilidad de pedido en este momento.
      </p>
    );
  };

  return (
    <div className="main-container">
      <div className="header-sede-main">
        <h1 className="title-sede-main">Nuevo pedido</h1>

        {isSedeUser && (
          <div className="sede-main-status">
            <SpinnerComponent isLoading={loading}>
              {renderEligibilityStatus()}
            </SpinnerComponent>
          </div>
        )}

        <Link to="/orders/add" className="mx-auto">
          <Button className="button-sede-main">Generar pedido</Button>
        </Link>
      </div>
    </div>
  );
};

export default SedeMain;
